import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { ModifiedLeaderboardPlayer } from '../../leaderboard.types';
import { t } from 'i18next';

import { ROUTES } from 'shared/constants/routes';
import { truncateAddress } from 'shared/utils/pretty-tx';

import CardsIcon from 'assets/svg/cards.svg?react';
import DiscordIcon from 'assets/svg/discord.svg?react';
import UserIcon from 'assets/svg/user.svg?react';

interface ILeaderboardLineProps {
  player: ModifiedLeaderboardPlayer;
  index: number;
  first: number;
}

export const LeaderboardYouLine: FC<ILeaderboardLineProps> = ({ player, index }) => {
  const { discordUsername, walletAddress, nftsTotal, gamesTotal, gamesWon, elo, percent } = player;
  const clampedPercent = Math.max(0, Math.min(percent, 100));
  const winPercent =
    gamesTotal > 0 ? Math.min(100, Math.max(0, Math.round((gamesWon / gamesTotal) * 100))) : 0;
  const navigate = useNavigate();
  const nftHandler = () => {
    if (walletAddress)
      window.open(`https://opensea.io/${walletAddress}`, '_blank', 'noopener,noreferrer');
  };
  if (!player) return null;
  return (
    <div className="fixed inset-x-0 bottom-20 z-50 mx-auto w-full max-w-screen-2xl bg-[linear-gradient(180deg,_#0A0A42_0%,_#020037_100%)] sm:bottom-40 md:bottom-0 md:-translate-x-2">
      <div
        className="absolute left-0 top-0 z-0 h-full bg-[linear-gradient(184deg,_#B36E1B_2.5%,_#373470_95.54%)]"
        style={{ width: `${clampedPercent}%` }}
      ></div>

      <div
        className={`relative grid w-full grid-cols-[4%_30%_12%_12%_12%_10%_20%] items-center p-2 text-sm text-white [font-variant-numeric:tabular-nums] sm:text-base`}
      >
        <span className="shrink-0">{index + 1}</span>
        <span
          role="button"
          tabIndex={0}
          className="flex cursor-pointer items-center gap-0.5 truncate"
          onClick={nftHandler}
        >
          {discordUsername ? <DiscordIcon className="h-4" /> : <UserIcon className="h-4" />}
          <span className="truncate">
            {' '}
            {discordUsername ? `@${discordUsername}` : truncateAddress(walletAddress)}
          </span>{' '}
        </span>

        <span className="flex items-center gap-0.5 text-left" role="button" onClick={nftHandler}>
          {nftsTotal}
          <CardsIcon className="h-4" />
        </span>
        <span className="text-left">{gamesTotal}</span>
        <span className="text-left">{winPercent}%</span>
        <span className="text-left">{elo}</span>
        <button
          className="justify-self-center text-[#FBD551]"
          onClick={() => {
            navigate(ROUTES.DAILY_QUESTS);
          }}
        >
          {t('leaderboard.quests')}
        </button>
      </div>
    </div>
  );
};
